import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

export class GalleryResultsModel {
    total: number;
    items: BookmarkModel[];
}
